var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"12px","text-align":"right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }